
<app-title-section></app-title-section>

<div class="card p-1"  style="margin-left: 15px; margin-right: 15px; min-height:100vh;">
    <ul
        *ngIf="currentStatus === 'ticke' || currentStatus === 'consolide'"
        class="nav nav-tabs m-0"
        style="border-bottom: 1px solid #eee;"
    >
        <li class="nav-item">
            <a
                class="nav-link"
                [routerLink]="['/tiers/ticketCaisse/ticke']"
                [class.active]="currentStatus === 'ticke'"
                (click)="selectInternalStatus('ticke')"
            >
                Tous
            </a>
        </li>
        <li class="nav-item">
            <a
                class="nav-link"
                [routerLink]="['/tiers/ticketCaisse/consolide']"
                [class.active]="currentStatus === 'consolide'"
                (click)="selectInternalStatus('consolide')"
            >
                Consolidation
            </a>
        </li>
    </ul>
    <div class="container-fluid" style="padding: 0; width: 100%; max-width: 100%;">
        <router-outlet></router-outlet>
    </div>
</div>

<app-annuler-multi-ticket-modal
    *ngIf="showAnnulerModal"
    [ticketIds]="annulerModalTicketIds"
    [isAdmin]="isAdmin"
    [submitting]="cancelSubmitting"
    (closed)="closeAnnulerModal()"
    (confirmCancel)="onConfirmAnnuler($event)"
></app-annuler-multi-ticket-modal>

<app-facturer-multi-ticket-modal
    *ngIf="showFacturerModal"
    [ticketIds]="facturerModalTicketIds"
    [submitting]="factureSubmitting"
    [allowConsolideTickets]="false"
    [financialProducts]="financialProducts"
    (closed)="closeFacturerModal()"
    (proceedToDocument)="onProceedFacturer($event)"
></app-facturer-multi-ticket-modal>
